import { useCallback } from "react";
import {
  Nav,
  Header,
  RestartButton,
  RightContainer,
  LanguageContainer,
} from "./styles";
import { LanguagePicker } from "../language-picker";
import { ModalType, usePatientInterest } from "context/patient-interest";
import { useRiskProfile } from "context/risk-profile";

export function ResultsHeader() {
  const { setModalType } = usePatientInterest();
  const riskProfile = useRiskProfile();
  const kioskRiskResult = riskProfile?.kioskRiskResult;

  const handleRestartClick = useCallback(() => {
    setModalType(ModalType.LOCK_RESTART);
  }, [setModalType]);

  return (
    <Header>
      <Nav role="nav">
        <img alt="CancerIQ logo" src="/ciq-logo.png" height="30" />
        {/* TODO: Do we need to clear any local storage data when naviagating
                back to the Kiosk landing after seeing results? */}
        <RightContainer>
          <LanguageContainer>
            <LanguagePicker />
          </LanguageContainer>
          {kioskRiskResult?.lockRestart ? (
            <RestartButton variant="outlined" onClick={handleRestartClick}>
              Restart
            </RestartButton>
          ) : (
            <RestartButton variant="outlined" href="/institution">
              Restart
            </RestartButton>
          )}
        </RightContainer>
      </Nav>
    </Header>
  );
}
